import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { UIError } from 'common/interfaces';
import {
  IDashboardDataType,
  IDashboardLoadingType,
  IDashboardState,
  IDashboardStats,
  IReportSalesStats,
  IReportStats,
  IStatsSearchCriteria,
} from 'common/interfaces/idashboard';
import { merge } from 'lodash';

const initialState: IDashboardState = {
  loading: false,
  error: null,
  loadingStatus: undefined,
  currentStats: undefined,
  previousStats: undefined,
  searchCriteria: undefined,
  currentSalesStats: undefined,
  previousSalesStats: undefined,
  currentGasSalesStats: undefined,
  previousGasSalesStats: undefined,
} as IDashboardState;

const reducers = {
  setLoading: (state: IDashboardState, action: PayloadAction<boolean>) => {
    state.loading = action.payload;
  },
  setDataLoading: (state: IDashboardState, action: PayloadAction<{ type: IDashboardDataType; isLoading: boolean }>) => {
    if (!state.loadingStatus) {
      state.loadingStatus = {} as IDashboardLoadingType;
    }
    state.loadingStatus[action.payload.type] = action.payload.isLoading;
  },
  setError: (state: IDashboardState, action: PayloadAction<UIError | null>) => {
    state.error = action.payload;
  },
  resetContext: (state: IDashboardState) => {
    merge(state, initialState);
  },
  setCurrentStats: (state: IDashboardState, action: PayloadAction<IDashboardStats | undefined>) => {
    state.currentStats = action.payload;
  },
  setPreviousStats: (state: IDashboardState, action: PayloadAction<IDashboardStats | undefined>) => {
    state.previousStats = action.payload;
  },
  setSearchCriteria: (state: IDashboardState, action: PayloadAction<IStatsSearchCriteria | undefined>) => {
    state.searchCriteria = action.payload;
  },
  setCurrentSalesStats: (state: IDashboardState, action: PayloadAction<IReportSalesStats[] | undefined>) => {
    state.currentSalesStats = action.payload;
  },
  setPreviousSalesStats: (state: IDashboardState, action: PayloadAction<IReportSalesStats[] | undefined>) => {
    state.previousSalesStats = action.payload;
  },

  setCurrentGasSalesStats: (state: IDashboardState, action: PayloadAction<IReportSalesStats[] | undefined>) => {
    state.currentGasSalesStats = action.payload;
  },
  setPreviousGasSalesStats: (state: IDashboardState, action: PayloadAction<IReportSalesStats[] | undefined>) => {
    state.previousGasSalesStats = action.payload;
  },

  setCurrentSalesStatsStoreWise: (state: IDashboardState, action: PayloadAction<IReportSalesStats[] | undefined>) => {
    state.currentSalesStatsStoreWise = action.payload;
  },
  setPreviousSalesStatsStoreWise: (state: IDashboardState, action: PayloadAction<IReportSalesStats[] | undefined>) => {
    state.previousSalesStatsStoreWise = action.payload;
  },

  setCurrentGasSalesStatsStoreWise: (
    state: IDashboardState,
    action: PayloadAction<IReportSalesStats[] | undefined>,
  ) => {
    state.currentGasSalesStatsStoreWise = action.payload;
  },
  setPreviousGasSalesStatsStoreWise: (
    state: IDashboardState,
    action: PayloadAction<IReportSalesStats[] | undefined>,
  ) => {
    state.previousGasSalesStatsStoreWise = action.payload;
  },
};

const dashboardSlice = createSlice({
  name: 'IDashboardState',
  initialState: initialState,
  reducers: reducers,
});

export default dashboardSlice.reducer;
export const DashboardActions = dashboardSlice.actions;
